<template>
    <div class="sku-sales-update" style="potistion: relative;">
        <compWrapper theme="primary" title="基本信息">
            <div class="margin-layout">
                <compFormQuery v-if="type == 'query'" :value="formData" :formdata="getBase"></compFormQuery>
                <compFormEdit v-else ref="validBaseInfo" v-model="formData" :formdata="getBase"></compFormEdit>
            </div>
        </compWrapper>
        <compWrapper theme="info" title="月度销售细分（USD）">
            <div class="margin-layout">
                <compFormQuery v-if="type == 'query'" :value="formData" :formdata="getSales"></compFormQuery>
                <compFormEdit v-else ref="validDetailInfo" v-model="formData" :formdata="getSales"></compFormEdit>
            </div>
        </compWrapper>
        <compWrapper v-if="type == 'query'" theme="gray" title="操作历史">
            <TableList class="margin-layout" v-bind="getTableProps"></TableList>
        </compWrapper>
        <div class="button-container text-right">
            <Button v-if="type != 'query'" class="margin-right-15" type="primary" @click="submit">确定</Button>
            <Button @click="cancel">取消</Button>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import {
    HttpGetDetail,
    HttpSaveDetail
} from "@/service/skusales/skusales";
import {
    HttpSysOpLog
} from '@/service/products/channel'
import TableList from "@components/templates/tablelist";
export default {
    props: ["querytype", "activeid"],
    components: {
        TableList
    },
    data () {
        return {
            id: this.activeid || this.$route.query.id,
            type: this.querytype || this.$route.params.type,
            formData: {},
            logList: [],
            loading: false,
        }
    },
    created () {
        console.log("querytype", this.type);
        if (this.type != 'add') {
            this.getDetail();
        }
    },
    computed: {
        ...mapGetters("dictionary", ["getProductList"]),
        getBase () {
            return [
                {
                    label: "ERP SKU",
                    key: "erpsku",
                    tag: "div",
                    children: (h) => {
                        return h("compErpSkuInput", {
                            props: {
                                value: this.formData.erpsku,
                            },
                            on: {
                                "on-data": (row) => {
                                    this.$set(this.formData, "erpsku", row.erpSku);
                                    this.$set(this.formData, "lineId", row.lineId);
                                    this.$set(this.formData, "productId", row.id);
                                    // this.formData.erpSku = row.erpSku;
                                    // this.formData.lineId = row.lineId;
                                }
                            },
                        })
                    },
                    style: {
                        "height": "32px"
                    },
                    query: this.type != "add"
                },
                {
                    label: "项目",
                    key: "lineId",
                    tag: "vSelect",
                    options: this.getProductList,
                    query: true
                },
                {
                    label: "销售月度",
                    key: "targetMonth",
                    tag: "vDatepicker",
                    props: {
                        format: "yyyy-mm",
                        confirm: false,
                    },
                    query: this.type == "query"
                },
                {
                    label: "销售总目标（USD）",
                    key: "totalTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    query: this.type == "query"
                }
            ];
        },
        getSales () {
            let showQuery = this.type == "query";
            return [
                {
                    label: "Amazon 1P",
                    key: "amazon1pTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    required: false,
                    query: showQuery,
                },
                {
                    label: "Amazon 3P",
                    key: "amazon3pTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    required: false,
                    query: showQuery
                },
                {
                    label: "Homedepot",
                    key: "homedepotTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    required: false,
                    query: showQuery
                },
                {
                    label: "Wayfair",
                    key: "wayfairTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    required: false,
                    query: showQuery
                },
                {
                    label: "Others",
                    key: "othersTargetValue",
                    tag: "vInputNumber",
                    props: {
                        min: 0
                    },
                    required: false,
                    query: showQuery
                },
            ];
        },
        getTableProps () {
            return {
				initFormData: {
                    search: {
                        EQ_opDataId: this.id,
                        EQ_opModel: "Product_Target"
                    },
				},
				ajaxRequest: HttpSysOpLog,
                startUp: true,
                columns: [
                    {
                        title: this.$t("global.common.operator", { defaultValue: "操作人" }),
                        key: "opUserName"
                    },
                    {
                        title: this.$t("global.common.operate_time", { defaultValue: "操作时间" }),
                        key: "opAt"
                    },
                    {
                        title: this.$t("erp.channel.operation_content", { defaultValue: "操作内容" }),
                        key: "opRemark",
                        render: (h, { row }) => {
                            return (
                                <div>
                                    <div>{this.$t("global.common.operate_type", { defaultValue: "操作类型" })}:{row.opAction}</div>
                                    <div>{this.$t("global.common.operate_note", { defaultValue: "操作原因" })}:{row.opRemark}</div>
                                </div>
                            );
                        }
                    }
                ],
            };
        },
    },
    methods: {
        async getDetail () {
            this.loading = true;
            await HttpGetDetail({
                id: this.id
            }).then(res => {
                this.formData = {
                    ...res.data
                };
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        async submit () {
            await this.$refs.validBaseInfo.validate();
            await this.$refs.validDetailInfo.validate();
            if (!this.formData.erpsku) return this.$VMessage.warning("请填写ERP SKU");
            this.loading = true;
            await HttpSaveDetail({
                id: this.id || null,
                orgId: global.SYSID,
                ...this.formData,
            }).then(res => {
                this.$VMessage.success(res.message);
                this.$emit("on-update");
                this.cancel();
            }, err => {
                this.$VMessage.error(err.message);
            });
            this.loading = false;
        },
        cancel () {
            if (this.$route.params.type) {
                this.$route.push({
                    name: "skuSalesList"
                });
            }
            else {
                this.$emit("on-close");
            }
        }
    }
}
</script>

<style>

</style>